// Must be the very first import of the app (see index.tsx).
//
// reflect-metadata (needed by class-transformer/car-schema) also installs
// Reflect.decorate. TypeScript's __decorate helper delegates to it when
// present, and Reflect.decorate rejects class decorators that return
// non-constructors — which is exactly what mobx-react's inject() returns
// (a functional forwardRef wrapper). The old fe-cli build used Babel
// decorators and never hit this path.
//
// Removing Reflect.decorate makes __decorate fall back to its own
// implementation (same semantics as Babel legacy decorators), while the
// metadata APIs (getMetadata/defineMetadata) stay intact.
import 'reflect-metadata';
delete Reflect.decorate;
